module.exports = __webpack_public_path__ + "static/media/bg-image-50.728b42fc.jpg";